import './services.logger';
import './services.recaptcha';
import './services.mobile-phone';
import { RECAPTCHA_VERIFICATION_FAILED } from '../../constants/recaptchable';
import shoplineCaptcha from '../../utils/shoplineCaptcha';
import { createDeferredPromise } from '../../utils/promise';
import { guardApiWithCaptcha } from '../../customElements/sl_armor_captcha/utils/armorCaptchaGuard';
import { ARMOR_CAPTCHA_SCENES } from '../../customElements/sl_armor_captcha';

app.directive('mobileCheckProcess', [
  '$filter',
  '$interval',
  '$q',
  '$timeout',
  '$window',
  'mobilePhoneService',
  'RecaptchaService',
  'mainConfig',
  'logger',
  'slFeatureService',
  function (
    $filter,
    $interval,
    $q,
    $timeout,
    $window,
    mobilePhoneService,
    RecaptchaService,
    mainConfig,
    logger,
    slFeatureService,
  ) {
    return {
      restrict: 'A',
      templateUrl: require('../../../../../public/themes/v1/default/views/templates.mobile-check-process.html'),
      scope: {
        resource: '=',
        mobileSignInStep: '@',
        formMode: '@',
        registrationFormSubmit: '&',
        getUserInfo: '&',
        simplifiedUi: '@',
        additionalErrorMessages: '<',
        resetRegistrationFormError: '&',
      },
      link: function (scope) {
        scope.isShowRecaptchaCheckbox = false;
        const isRecaptchaEnterpriseError = (errorCode) =>
          errorCode === RECAPTCHA_VERIFICATION_FAILED &&
          !scope.isShowRecaptchaCheckbox &&
          mainConfig.isRecaptchaEnterprise;

        scope.recaptchaElementIds = {
          sendCode: 'mobile-signup-send-code-recaptcha',
          resendCode: 'mobile-signup-re-send-code-recaptcha',
        };
        scope.recaptchaCheckboxIds = {
          sendCode: 'mobile-signup-send-code-recaptcha-checkbox',
          resendCode: 'mobile-signup-re-send-code-recaptcha-checkbox',
        };

        scope.mobileCodeForm = {
          submitting: false,
        };
        scope.hasShoplineCaptcha =
          slFeatureService.hasFeature('shopline_captcha');
        const armorCaptchaScene = {
          forgotPassword: ARMOR_CAPTCHA_SCENES.FORGOT_PASSWORD_SMS,
          registration: ARMOR_CAPTCHA_SCENES.REGISTRATION_SMS,
        }[scope.formMode];
        const enableShoplineCaptcha =
          scope.hasShoplineCaptcha && !!armorCaptchaScene;
        const enableSubmitCodeTokens =
          scope.hasShoplineCaptcha && scope.formMode === 'registration';
        // if isRecaptchaEnabled will not always be true in the future, then when enableShoplineCaptcha is true, isRecaptchaEnabled must be true.
        scope.isRecaptchaEnabled = true;
        const merchantRecaptchaEnabled = mainConfig.isRecaptchaEnabled;
        scope.submitCodeBtnId = 'mobile-signup-submit-code-btn';
        scope.shoplineCaptchaListener = {
          sendCode: null,
          resendCode: null,
          submitCode: null,
        };
        let deferredSendCodeMToken = createDeferredPromise();
        let deferredSubmitCodeMToken = createDeferredPromise();
        let countdownInterval = null;
        let unsubscribe = null;
        const unsubscribeCheckboxes = [];

        scope.$on('mobile-step-change', function (event, step) {
          scope.mobileSignInStep = step;
          scope.isShowRecaptchaCheckbox = false;
          deferredSendCodeMToken = createDeferredPromise();

          if (
            step === 'check_mobile' &&
            RecaptchaService.checkRecaptchaIsNotReady()
          ) {
            logger.error('failed to load recaptcha', {
              grecaptcha: window.grecaptcha,
              isRecaptchaEnterprise: mainConfig.isRecaptchaEnterprise,
            });
            if (scope.simplifiedUi) {
              scope.mobileCodeForm.errorMessages = [
                $filter('translate')(
                  'session.mobile_signup.recaptcha.load.failure',
                ),
              ];
            }
          }
        });

        scope.goBack = function ($event) {
          if (!scope.mobileCodeForm.submitting) {
            RecaptchaService.reset('submit-btn');
            $event.preventDefault();
            scope.mobileCodeForm.errorMessages = null;
            if (scope.resetRegistrationFormError)
              scope.resetRegistrationFormError();
            scope.$emit('mobile-step-change');
            if (countdownInterval) $interval.cancel(countdownInterval);
            deferredSendCodeMToken = createDeferredPromise();
          }
        };

        scope.sendCode = function (
          shoplineCaptchaDFPToken,
          shoplineCaptchaMToken,
        ) {
          let sendCodeFunc;
          switch (scope.formMode) {
            case 'forgotPassword':
              sendCodeFunc = 'sendForgetPasswordCode';
              break;
            case 'registration':
              sendCodeFunc = 'sendSignUpCode';
              break;
            case 'member_center':
            default:
              sendCodeFunc = 'sendMobileChangeCode';
          }
          const payload = {
            countryCallingCode: scope.resource.countryCallingCode,
            mobilePhone: scope.resource.mobilePhone,
            recaptchable: scope.isRecaptchaEnabled,
            m_token: shoplineCaptchaMToken,
            dfp_token: shoplineCaptchaDFPToken,
            isUseCheckbox: scope.isShowRecaptchaCheckbox,
          };
          scope.isShowRecaptchaCheckbox = false;
          const request = (extra = {}) =>
            mobilePhoneService[sendCodeFunc]({ ...payload, ...extra });
          const sendCodePromise = enableShoplineCaptcha
            ? $q.when(
                guardApiWithCaptcha({
                  scene: armorCaptchaScene,
                  request,
                }),
              )
            : request();
          sendCodePromise.then(
            function () {
              scope.mobileCodeForm.submitting = false;
              scope.mobileSignInStep = 'enter_code';
              scope.resendCountdown = 60;
              countdownInterval = $interval(function () {
                scope.resendCountdown--;
                if (scope.resendCountdown === 0) {
                  $interval.cancel(countdownInterval);
                }
              }, 1000);
              deferredSendCodeMToken = createDeferredPromise();
            },
            function (response) {
              scope.mobileCodeForm.submitting = false;
              if (isRecaptchaEnterpriseError(response?.data?.error_code)) {
                scope.isShowRecaptchaCheckbox = true;
                renderRecaptchaCheckbox();
                return;
              }
              scope.isShowRecaptchaCheckbox = false;
              deferredSendCodeMToken = createDeferredPromise();
              scope.mobileCodeForm.errorMessages = response.data.error
                ? [response.data.error]
                : [response.data.error_messages];
            },
          );
        };

        // getListener returns undefined when the SDK is unavailable, and
        // nothing would ever resolve the deferred -- sending the code must not
        // hang on a risk SDK that never loaded.
        const getSendCodeMToken = () =>
          scope.shoplineCaptchaListener.sendCode ||
          scope.shoplineCaptchaListener.resendCode
            ? deferredSendCodeMToken.promise
            : $q.resolve(undefined);

        const getSubmitCodeTokens = () => {
          if (!enableSubmitCodeTokens) return $q.resolve({});
          return $q
            .all([
              $q.when(shoplineCaptcha.getTokenAsync()).catch(() => undefined),
              scope.shoplineCaptchaListener.submitCode
                ? deferredSubmitCodeMToken.promise
                : $q.resolve(undefined),
            ])
            .then(([dfp_token, m_token]) => ({ dfp_token, m_token }));
        };

        scope.checkShoplineCaptchaOnSubmit = async () => {
          const promises = [];
          if (enableShoplineCaptcha) {
            promises.push(
              // should not break the flow if shoplineCaptcha.getTokenAsync
              // fails -- it returns undefined, not a promise, when the SDK is
              // unavailable, so wrap before attaching the handler
              $q.when(shoplineCaptcha.getTokenAsync()).catch(() => undefined),
              getSendCodeMToken(),
            );
          }
          scope.mobileCodeForm.submitting = true;
          scope.mobileCodeForm.errorMessages = null;
          $q.all(promises).then(
            ([shoplineCaptchaDFPToken, shoplineCaptchaMToken]) =>
              scope.sendCode(shoplineCaptchaDFPToken, shoplineCaptchaMToken),
          );
        };

        scope.formSubmit = function () {
          scope.mobileCodeForm.submitting = true;
          scope.mobileCodeForm.errorMessages = null;

          if (!scope.resource.code) {
            scope.mobileCodeForm.submitting = false;
            return;
          }

          if (scope.formMode == 'forgotPassword') {
            mobilePhoneService
              .verifyCode({
                countryCallingCode: scope.resource.countryCallingCode,
                mobilePhone: scope.resource.mobilePhone,
                code: scope.resource.code,
                isForgetPassword: true,
              })
              .then(
                function (res) {
                  $window.location.href =
                    '/users/password/edit?reset_password_token=' +
                    res.data.reset_password_token +
                    $window.location.search.replace('?', '&') +
                    '&reset=true' +
                    '&from=mobile';
                },
                function (error) {
                  scope.mobileCodeForm.errorMessages =
                    error.data.error_messages;
                  scope.mobileCodeForm.submitting = false;
                },
              );
          } else if (
            scope.formMode == 'registration' &&
            typeof scope.registrationFormSubmit === 'function'
          ) {
            let promise = $q.resolve();
            if (merchantRecaptchaEnabled || scope.hasShoplineCaptcha) {
              promise = RecaptchaService.executeWithPromise();
            }

            promise
              .then(getSubmitCodeTokens)
              .then(function (extraPayload) {
                return scope.registrationFormSubmit({ extraPayload });
              })
              .then(function () {
                scope.mobileCodeForm.submitting = true;
              })
              .finally(function () {
                deferredSubmitCodeMToken = createDeferredPromise();
              })
              .catch(function () {
                scope.mobileCodeForm.submitting = false;
              });
          } else if (
            scope.formMode == 'member_center' &&
            typeof scope.getUserInfo === 'function'
          ) {
            var params = {
              countryCallingCode: scope.resource.countryCallingCode,
              mobilePhone: scope.resource.mobilePhone,
              code: scope.resource.code,
            };

            mobilePhoneService.verifyCode(params).then(
              function success() {
                scope.mobileCodeForm.submitting = false;
                scope.$emit('mobile-step-change');
                scope.getUserInfo();
              },
              function error(error) {
                scope.mobileCodeForm.submitting = false;
                scope.mobileCodeForm.errorMessages = error.data.error_messages;
              },
            );
          }
        };

        const handleRecaptchaClickCallback = () => {
          scope.mobileCodeForm.submitting = true;
          scope.mobileCodeForm.errorMessages = null;
          scope.$apply();
        };

        const handleRecaptchaErrorCallback = () => {
          scope.mobileCodeForm.submitting = false;
          if (scope.simplifiedUi) {
            scope.mobileCodeForm.errorMessages = [
              $filter('translate')(
                'session.mobile_signup.recaptcha.token.failure',
              ),
            ];
          }
        };

        const renderedCheckboxIds = new Set();
        const renderRecaptchaCheckbox = () => {
          const id =
            scope.mobileSignInStep === 'enter_code'
              ? scope.recaptchaCheckboxIds.resendCode
              : scope.recaptchaCheckboxIds.sendCode;
          if (renderedCheckboxIds.has(id)) return;
          renderedCheckboxIds.add(id);

          // ensure ng-show has revealed the element
          $timeout(() => {
            // safe to subscribe late: globalSDKObserver.subscribe invokes
            // immediately when the SDK is already there
            unsubscribeCheckboxes.push(
              RecaptchaService.waitRecaptchaLoaded(() => {
                const element = document.getElementById(id);
                if (!element) return;

                RecaptchaService.renderRecaptchaWidget({
                  element,
                  callback: scope.checkShoplineCaptchaOnSubmit,
                  clickCallback: handleRecaptchaClickCallback,
                  errorCallback: handleRecaptchaErrorCallback,
                  timeoutCallback: handleRecaptchaErrorCallback,
                  isInvisible: false,
                });
              }),
            );
          });
        };

        if (scope.isRecaptchaEnabled) {
          // ensure the elements have finished rendering
          $timeout(() => {
            unsubscribe = RecaptchaService.waitRecaptchaLoaded(() => {
              Object.values(scope.recaptchaElementIds).forEach((id) => {
                const recaptchaElement = document.getElementById(id);
                if (recaptchaElement) {
                  RecaptchaService.renderRecaptchaWidget({
                    element: recaptchaElement,
                    callback: scope.checkShoplineCaptchaOnSubmit,
                    clickCallback: handleRecaptchaClickCallback,
                    errorCallback: handleRecaptchaErrorCallback,
                    timeoutCallback: handleRecaptchaErrorCallback,
                  });
                }
              });

              if (enableShoplineCaptcha) {
                Object.assign(scope.shoplineCaptchaListener, {
                  sendCode: shoplineCaptcha.getListener(
                    scope.recaptchaElementIds.sendCode,
                    (shoplineCaptchaMToken) =>
                      deferredSendCodeMToken.resolve(shoplineCaptchaMToken),
                  ),
                  resendCode: shoplineCaptcha.getListener(
                    scope.recaptchaElementIds.resendCode,
                    (shoplineCaptchaMToken) =>
                      deferredSendCodeMToken.resolve(shoplineCaptchaMToken),
                  ),
                });
              }
            });
          });
        }
        if (enableSubmitCodeTokens) {
          $timeout(() => {
            if (!document.getElementById(scope.submitCodeBtnId)) return;

            scope.shoplineCaptchaListener.submitCode =
              shoplineCaptcha.getListener(scope.submitCodeBtnId, (mToken) =>
                deferredSubmitCodeMToken.resolve(mToken),
              );
          });
        }

        scope.$on('$destroy', () => {
          RecaptchaService.cancelRecaptchaTimer();
          unsubscribe?.();
          unsubscribeCheckboxes.forEach((unsubscribeCheckbox) =>
            unsubscribeCheckbox?.(),
          );
          Object.values(scope.shoplineCaptchaListener).forEach((listener) =>
            listener?.destroy(),
          );
        });
      },
    };
  },
]);
